import { Component, For } from 'solid-js';
import { Portal } from 'solid-js/web';
import { OptionalTierLock } from '@trimble/tiering';
import { AdoptReusableStylesheets } from '@trimble/stylesheets';
import { web3dWebComponentsWithModusStylesheets } from '../../stylesheets';
import { ContextMenuItemConfig } from './context-menu.types';

export interface ContextMenuProps {
  show: boolean;
  dataItem: Record<string, unknown>;
  contextMenuItems: ContextMenuItemConfig[];
  onCloseMenu(): void;
  ref: HTMLDivElement;
}

const ContextMenu: Component<ContextMenuProps> = (props) => {
  return (
    <Portal useShadow={true} mount={document.body}>
      <AdoptReusableStylesheets
        stylesheets={web3dWebComponentsWithModusStylesheets}
      />
      <div
        ref={props.ref}
        style={{
          display: props.show ? 'flex' : 'none',
        }}
        class="flex-col absolute rounded-sm bg-white border border-gray-1 z-dropdown-elevated"
      >
        <modus-list>
          <For each={props.contextMenuItems}>
            {(menuItem) => (
              <OptionalTierLock options={menuItem.accessConfig}>
                <modus-wc-tooltip
                  content={menuItem.disabledReasonTooltip ?? ''}
                  disabled={
                    !menuItem.disabled || !menuItem.disabledReasonTooltip
                  }
                  position="bottom"
                >
                  <div
                    data-testid={`context-menu-item-${menuItem.reference}`}
                    class={menuItem.disabled ? 'disabled' : undefined}
                  >
                    <modus-list-item
                      class={`[&:not(:first-child)]:border-t border-gray-light transition-colors duration-300 w-full text-left block ${menuItem.disabled ? 'context-menu-item--disabled' : 'cursor-pointer hover:bg-gray-light'}`}
                      onClick={(e: Event) => {
                        if (menuItem.disabled) {
                          e.preventDefault();
                          return;
                        }
                        menuItem.handleMenuAction(props.dataItem, {
                          event: e,
                          value: menuItem.reference,
                        });
                        props.onCloseMenu();
                      }}
                      borderless
                      aria-disabled={menuItem.disabled ? 'true' : undefined}
                    >
                      <span>{menuItem.label}</span>
                    </modus-list-item>
                  </div>
                </modus-wc-tooltip>
              </OptionalTierLock>
            )}
          </For>
        </modus-list>
      </div>
    </Portal>
  );
};

export default ContextMenu;
